export let life = {
}
export let event = {
    prevyear () {
        this.methods('prev')
    },
    nextyear () {
        this.methods('next')
    },
    select(data) {
        this.methods('selectSeason',data)
    }
}
